var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Fragment } from 'react';
import styled, { css } from 'styled-components';
import { STACK_ALIGN, STACK_GAP, StackView } from "../StackView";
import { INDENT } from "../View";
import { TOOLBAR_ITEM_TYPE, TOOLBAR_VIEW_TYPE } from './types';
import { defaultGroupDecorator } from './defaultGroupDecorator';
import { processItem as defaultProcessItem } from './processItem';
import { ToolbarControls } from './controls/ToolbarControls';
import { createUIElement, SIZE_XXL } from "../helpers";
import { useGuard } from '@veeam/core';
var StyledStackView = styled(StackView)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    height: ", ";\n    flex-shrink: 0;\n    min-width: max-content;\n    ", "\n"], ["\n    height: ", ";\n    flex-shrink: 0;\n    min-width: max-content;\n    ",
    "\n"])), SIZE_XXL, function (_a) {
    var theme = _a.theme, view = _a.view;
    return view === TOOLBAR_VIEW_TYPE.spotted && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            background-color: ", ";\n        "], ["\n            background-color: ", ";\n        "])), theme.colors.backgrounds.neutral);
});
export var calcSpaceHorizontal = function (view, buildIn) {
    return view === TOOLBAR_VIEW_TYPE.spotted || buildIn ? INDENT.s : INDENT.none;
};
/**
 * Layout for build Toolbar
 */
export var ToolbarLayout = createUIElement('ToolbarLayout', function (_a, ref) {
    var className = _a.className, children = _a.children, _b = _a.view, view = _b === void 0 ? TOOLBAR_VIEW_TYPE.default : _b, _c = _a.buildIn, buildIn = _c === void 0 ? false : _c, testId = _a.testId, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, style = _a.style, rest = __rest(_a, ["className", "children", "view", "buildIn", "testId", "onMouseEnter", "onMouseLeave", "style"]);
    return (React.createElement(StyledStackView, __assign({}, rest, { testId: rest['data-selector-id'] || testId || 'toolbar-layout', className: "vm-ToolbarLayout " + className, gap: STACK_GAP.xl, align: STACK_ALIGN.center, view: view, spaceHorizontal: calcSpaceHorizontal(view, buildIn), onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, ref: ref, style: style }), children));
});
var OffsetWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: inline-flex;\n    flex-shrink: 0;\n    ", "\n"], ["\n    display: inline-flex;\n    flex-shrink: 0;\n    ",
    "\n"])), function (_a) {
    var hasOffset = _a.hasOffset;
    return hasOffset && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            &:nth-child(n + 2) > * {\n                margin: 0 -8px;\n            }\n            &:last-child > * {\n                margin-right: 0;\n            }\n        "], ["\n            &:nth-child(n + 2) > * {\n                margin: 0 -8px;\n            }\n            &:last-child > * {\n                margin-right: 0;\n            }\n        "])));
});
export var Toolbar = createUIElement('Toolbar', function (_a, ref) {
    var className = _a.className, items = _a.items, _b = _a.groups, groups = _b === void 0 ? [] : _b, _c = _a.payload, payload = _c === void 0 ? {} : _c, disabled = _a.disabled, view = _a.view, _d = _a.buildIn, buildIn = _d === void 0 ? false : _d, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, style = _a.style, rest = __rest(_a, ["className", "items", "groups", "payload", "disabled", "view", "buildIn", "onMouseEnter", "onMouseLeave", "style"]);
    var canAction = useGuard().canAction;
    var toolbarItems = items.filter(Boolean).map(function (item) { return (__assign(__assign({}, item), { disabled: disabled || item.disabled })); });
    var processedItems = defaultGroupDecorator(toolbarItems, groups, payload || null, canAction);
    var buildContent = function (itemProps, idx) {
        if (!itemProps) {
            return null;
        }
        var key = itemProps.type + "-" + (itemProps.id || idx);
        if (itemProps.type === TOOLBAR_ITEM_TYPE.customControl &&
            itemProps.render &&
            !itemProps.hidden) {
            return (React.createElement(OffsetWrapper, { key: key, "data-has-offset": itemProps.hasOffset ? true : undefined, hasOffset: !!itemProps.hasOffset }, itemProps.render({ disabled: !!itemProps.disabled })));
        }
        if (itemProps.type in TOOLBAR_ITEM_TYPE) {
            var type = itemProps.type, id = itemProps.id, restItemProps = __rest(itemProps, ["type", "id"]);
            return (React.createElement(Fragment, { key: key }, React.createElement(ToolbarControls[type], __assign(__assign({}, restItemProps), { 'data-selector-id': id
                    ? "toolbar-item-" + id
                    : "toolbar-" + type.toLowerCase() }))));
        }
        console.warn("A type '" + itemProps.type + "' is unknown in 'Toolbar'. The type props of item should be as TOOLBAR_ITEM_TYPE.");
        return null;
    };
    return (React.createElement(ToolbarLayout, __assign({}, rest, { testId: rest['data-selector-id'] || 'toolbar-layout', className: "vm-Toolbar " + className, view: view, buildIn: buildIn, "data-toolbar": true, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, "data-eat-indent": view !== TOOLBAR_VIEW_TYPE.spotted, ref: ref, style: style }), processedItems
        .map(function (itemProps) {
        return defaultProcessItem(payload, itemProps, canAction);
    })
        .filter(Boolean)
        .map(buildContent)));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Toolbar.js.map